export default __webpack_public_path__ + "static/media/coming-soon-rsa.f7b16d3b.svg";